/**
 * Shared stylesheet for printable product reports (list and detail).
 */
export const PRODUCT_REPORT_CSS_STYLE = `
body {
    margin: 0;
    font-family: "Helvetica Neue", Helvetica, Georgia, "Times New Roman", serif;
}

.report {
    color: black;
    background-color: white;
    padding: 20px 10px;
}

.report h1 {
    margin: 10px 0px 5px 0px;
    font-size: 20px;
}

.report h1.small {
    font-size: 16px !important;
}

.report .title {
    margin-bottom: 15px;
}

.report.product .report-product-heading {
    margin-bottom: 12px;
}

.report.product .report-product-heading h1 {
    margin: 0 0 4px 0;
    text-align: left;
}

.report.product .report-product-period {
    margin: 0;
    padding: 0;
    text-align: left;
    font-size: 14px;
    font-weight: normal;
}

.report.product .chart-title {
    margin: 0 0 6px 0;
}

.report.product .chart-title h1.small {
    margin: 0;
    text-align: left;
    font-weight: bold;
}

.report.product .chart-box {
    box-sizing: border-box;
    margin-bottom: 14px;
    overflow: hidden;
}

.report.product .chart-box:last-of-type {
    margin-bottom: 0;
}

.report.product .chart-box upp-chart {
    display: block;
    height: 100%;
    max-height: 100%;
}

.report .chart-box img {
    display: block;
    width: 100%;
    max-width: 100%;
    height: auto;
    object-fit: contain;
}

.report h2 {
    text-align: center;
    margin: 0px 0px 5px 0px;
    font-size: 18px;
}

.report table {
    width: 100%;
    border-collapse: collapse;
}

.report table tr {
    border-bottom: 1px solid #666;
}

.report table tr td {
    padding: 10px 15px;
}

.report table tr td.right {
    text-align: right;
    max-width: fit-content;
}

.report.product .report-product-typebrief {
    margin-bottom: 20px;
}

.report.product .report-product-tickets {
    margin-top: 8px;
}

.report .items {
    padding: 10px 0px;
    font-size: 13px;
}

.report .items table {
    width: 100%;
    border: 1px solid #ddd;
    border-collapse: collapse;
}

.report .items table th {
    padding: 6px 5px;
    border-bottom: 1px solid #666;
    font-weight: bold;
    text-align: left;
}

.report .items table tr {
    border-bottom: none !important;
}

.report .items table tbody tr:nth-child(odd) {
    background-color: #ddd;
}

.report .items table td {
    padding: 3px 5px;
}

.report .empty {
    text-align: center;
    padding: 20px;
}

.report .empty .small {
    font-size: 80%;
    opacity: 0.8;
}

.report upp-chart {
    display: block;
    width: 100%;
}
`.trim();

/**
 * Returns CSS for printable product report documents.
 */
export const productStyle = (): string => {
    return PRODUCT_REPORT_CSS_STYLE;
};
